import $ from 'jquery'
import { scrollTo }  from './helpers'

let triggerId = "as-focus-1"
let headSelector = "h2"
let contentSelector = ".item-full"
let inited = false
let section = false
let sectionHeading = false
let sectionTitle = ""

const getFocusableChildren = (el) => {
  return [...el.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')]
}
const getFirstFocusable = (el) => {
  const focusableEls = getFocusableChildren(el)
  return focusableEls.length > 0 ? focusableEls[0] : false
}
const initFfOnce = () => {
  if (!inited) {
    inited = true
    $("body").on("click", "#" + triggerId, onFfClick)
  }
}

const onFfClick = (e) => {
  e.preventDefault()
  if (sectionHeading && section) {
    scrollTo($(sectionHeading), 40)
    const first = getFirstFocusable(section)
    if (first) {
      first.focus()
    }
  }
}
const getFfTrigger = () => {
  return document.getElementById(triggerId)
}
const getFfHeadings = () => {
  return [...document.querySelectorAll(headSelector)]
}
const getFfHeading = () => {
  const list = getFfHeadings()
  return list.length > 0 ? list[0] : false
}
const getFfSections = () => {
  return [...document.querySelectorAll(contentSelector)]
}
const getFfSection = () => {
  const list = getFfSections()
  return list.length > 0 ? list[0] : false
}

export const firstFocusUpdate = () => {
  const trigger = getFfTrigger()
  if (trigger) {
    initFfOnce()
    section = getFfSection()
    sectionHeading = getFfHeading()
    sectionTitle = sectionHeading ? sectionHeading.textContent : ""
    const titSpan = trigger.querySelector("span")
    if (titSpan) {
      titSpan.innerHTML = sectionTitle
    } else {
      titSpan.innerHTML = ""
    }
    if (section && sectionHeading) {
      trigger.style.display = "block"
    } else {
      trigger.style.display = "none"
    }
  }
}